module.exports = __webpack_public_path__ + "static/backgroundImage-98a61a87ddff81200ccae7702fedd489.png";